import React from 'react';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Typography from '@mui/material/Typography';

import { useInterval } from '@tzmedical/react-hooks';

import axios from '../../axiosClient.js';
import Alert from '../common/Alert.jsx';
import PageLoading from '../common/PageLoading.jsx';
import MonthlyCommissionsHeader from '../MonthlyCommissionsHeader.jsx';
import CommGrossMonthlyCommissionsRow from './CommGrossMonthlyCommissionsRow.jsx';

const REFRESH_INTERVAL_MS = 300_000;

function CommGrossMonthlyCommissionsTable({ selectedRep, selectedYear }) {
  const [alertError, setAlertError] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [monthlyCommissions, setMonthlyCommissions] = React.useState([]);

  const fetchMonthlyCommissions = React.useCallback(async () => {
    try {
      const { data } = await axios.get(
        `/api/commgross/monthly-commissions/${encodeURIComponent(selectedRep)}/${selectedYear}`
      );
      setMonthlyCommissions(data);
      setAlertError(null);
    } catch (err) {
      setAlertError(err.response?.data?.error || err.message);
    }
    setLoading(false);
  }, [selectedRep, selectedYear]);

  React.useEffect(() => {
    setLoading(true);
    setAlertError(null);
    setMonthlyCommissions([]);
  }, [selectedRep, selectedYear]);

  useInterval(fetchMonthlyCommissions, REFRESH_INTERVAL_MS, loading && !alertError);

  return (
    <Box>
      <Typography variant="h5" sx={{ textAlign: 'center' }}>
        Monthly Commissions — Annual Gross Tiers
      </Typography>
      <Alert message={alertError} setMessage={setAlertError} level="error" />
      {loading ? (
        <PageLoading />
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <MonthlyCommissionsHeader />
            </TableHead>
            <TableBody>
              {monthlyCommissions.map((monthCommission) => (
                <CommGrossMonthlyCommissionsRow
                  key={monthCommission.category}
                  monthCommission={monthCommission}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}

export default React.memo(CommGrossMonthlyCommissionsTable);
